// eslint-disable-next-line
export const TOGGLE_NOTIFICATION_DRAWER = 'activitystream/toggle-notification-drawer';
export const ADD_NOTIFICATIONS = 'activitystream/add-notifications';
export const UPDATE_NOTIFCATION = 'activitystream/update-notification';
